export const GROWTHBOOK_INTERNAL_STATE = '__GROWTHBOOK_INTERNAL_STATE__'
export const GROWTHBOOK_ATTRIBUTES = '__GROWTHBOOK_ATTRIBUTES__'
export const GROWTHBOOK_EXPERIMENT_EVENT_NAME = 'Experiment.Participate'
